import GalleryList from "~/components/GalleryList";
import { getLink, trans } from "~/providers/lang";
import { ROUTES } from "~/const";
import { useSeo } from "~/hooks/useSeo";
import { mainStore } from "~/stores/main";

export default function GalleryShopPage() {
	useSeo({
		title: trans("skelet.title.home"),
		canonical: "galerie-prodejna",
	});

	const pageData = mainStore(state => state.data.pageData);
	const source = pageData.photos.shop;

	return <GalleryList baseUrl={getLink(ROUTES.galleryShop)} title={trans("template.shop")} source={source} />;
}
